module.exports = __webpack_public_path__ + "static/media/HCMM257.d71fc05e.jpg";